import React from 'react';
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
} from 'react-router-dom';

import { permittedLinks } from '../layout';
import { PageStocks, PageStock } from '../pages/stocks';
import { PageStockRecords, PageStockRecord } from '../pages/stockRecords';
import { PagePreStocks, PagePreStock } from '../pages/prestocks';
import { PageRestocks, PageRestock } from '../pages/restocks';
import { PageReadyToShips } from '../pages/readyToShip';
import { PageStockTrans, PageStockTran } from '../pages/stocksTrans';
import { PageTfyStock, PageTfyStocks } from '../pages/tfyStocks';

const RouteStocks = () => {
  const { path } = useRouteMatch();
  const user = permittedLinks.find(
    ({ segment }) => segment === 'stocks',
  );

  return (
    <Switch>
      <Route exact path={path}>
        <Redirect
          to={user?.links?.[0]?.to || `${path}/self`}
        />
      </Route>
      <Route exact path={`${path}/items`}>
        <PageStocks />
      </Route>
      <Route path={`${path}/items/:_id`}>
        <PageStock />
      </Route>
      <Route exact path={`${path}/reorders/items`}>
        <PageRestocks />
      </Route>
      <Route path={`${path}/reorders/items/:_id`}>
        <PageRestock />
      </Route>
      <Route exact path={`${path}/tfy/items`}>
        <PageTfyStocks />
      </Route>
      <Route path={`${path}/tfy/items/:_id`}>
        <PageTfyStock />
      </Route>
      <Route exact path={`${path}/records`}>
        <PageStockRecords />
      </Route>
      <Route path={`${path}/records/:_id`}>
        <PageStockRecord />
      </Route>
      <Route exact path={`${path}/pre-stocks`}>
        <PagePreStocks />
      </Route>
      <Route path={`${path}/pre-stocks/:_id`}>
        <PagePreStock />
      </Route>
      <Route exact path={`${path}/ready-to-ship`}>
        <PageReadyToShips />
      </Route>
      <Route exact path={`${path}/trans`}>
        <PageStockTrans />
      </Route>
      <Route path={`${path}/trans/:_id`}>
        <PageStockTran />
      </Route>
    </Switch>
  );
};

export default RouteStocks;
